import { render } from "./PriceIndicator.vue?vue&type=template&id=f80adcd4"
import script from "./PriceIndicator.vue?vue&type=script&lang=js"
export * from "./PriceIndicator.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__